import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button, Row, Col, Form, Input, Switch } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getSchoolConfig, updateSchoolConfig } from './ecoleConfig.reducer';

const PEDAGOGIE_MENU_ENABLED = 'PEDAGOGIE_MENU_ENABLED';
const PEDAGOGIE_ENABLED_LEGACY = 'PEDAGOGIE_ENABLED';
const PEDAGOGIE_MENU_LABEL = 'Menu Pédagogie';

const isPedagogieMenuConfig = (configKey?: string) => configKey === PEDAGOGIE_MENU_ENABLED || configKey === PEDAGOGIE_ENABLED_LEGACY;

export const EcoleConfigUpdate = (props: RouteComponentProps<{ ecoleId: string; configId: string }>) => {
  const { match } = props;

  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const config = useAppSelector(state => state.ecoleConfig.entity);

  useEffect(() => {
    dispatch(getSchoolConfig(match.params.configId));
  }, [dispatch, match.params.configId]);

  useEffect(() => {
    if (config && config.id) {
      form.setFieldsValue({
        ...config,
        valueBoolean: config.value === 'true',
      });
    }
  }, [config, form]);

  const isPedagogieConfig = isPedagogieMenuConfig(config?.configKey);

  const handleClose = () => {
    props.history.push(`/ecole-config/${match.params.ecoleId}`);
  };
  const goBack = () => {
    props.history.goBack();
  };
  const saveEntity = values => {
    const { valueBoolean, ...restValues } = values;
    const entity = {
      ...config,
      ...restValues,
      value: isPedagogieConfig ? String(valueBoolean) : values.value,
    };
    dispatch(updateSchoolConfig(entity));
    handleClose();
  };
  return (
    <>
      {config.id !== null && (
        <Modal
          title="Modifier Ecole-Configuration"
          centered
          footer={[
            <Button key="back" onClick={goBack}>
              Annuler
            </Button>,
          ]}
          visible={true}
          closable={false}
        >
          <Row className="justify-content-center">
            <Col span={18} offset={4}>
              <Form
                form={form}
                labelCol={{ span: 4 }}
                onFinish={saveEntity}
                wrapperCol={{ span: 14 }}
                layout="vertical"
                size="large"
                initialValues={config}
              >
                <Form.Item label="Clé">
                  <Input value={isPedagogieConfig ? PEDAGOGIE_MENU_LABEL : config?.configKey} readOnly />
                </Form.Item>
                {isPedagogieConfig ? (
                  <Form.Item label="Valeur" name="valueBoolean" valuePropName="checked">
                    <Switch checkedChildren="Activé" unCheckedChildren="Désactivé" />
                  </Form.Item>
                ) : (
                  <Form.Item label="Valeur" name="value">
                    <Input placeholder="value" />
                  </Form.Item>
                )}
                <Form.Item>
                  <Button
                    style={{ backgroundColor: '#F28E19', color: 'white' }}
                    data-cy="entityCreateSaveButton"
                    htmlType="submit"
                    id="save-entity"
                  >
                    <FontAwesomeIcon icon="save" />
                    &nbsp; Enregistrer
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Modal>
      )}
    </>
  );
};

export default EcoleConfigUpdate;
